<template>
  <div class="home">
    <!-- 顶部导航 -->
    <nav class="navbar">
      <div class="nav-content">
        <div class="logo-container">
          <img src="@/assets/logo.png" alt="恰恰好" class="logo-img">
          <div class="logo-text">恰恰好</div>
        </div>
        <div class="nav-links">
          <a @click.prevent="scrollToSection('features-section')">功能</a>
          <a @click.prevent="scrollToSection('download-section')">下载</a>
        </div>
      </div>
    </nav>

    <!-- 主要内容区 -->
    <main>
      <!-- 英雄区域 -->
      <section class="hero">
        <div class="hero-content">
          <h1>智能饮食分析助手</h1>
          <p class="hero-subtitle">拍照识别食物，即刻了解营养成分</p>
        </div>
      </section>

      <!-- 功能特点 -->
      <section id="features-section" class="features">
        <div class="features-bg"></div>
        <div class="features-header">
          <h2>探索智能饮食新体验</h2>
          <p class="features-subtitle">让每一餐都充满智慧，让健康触手可及</p>
        </div>
        <div class="feature-grid">
          <div class="feature-card">
            <i class="fas fa-camera"></i>
            <h3>智能识别</h3>
            <p>拍照或描述食物，AI 精准识别</p>
          </div>
          <div class="feature-card">
            <i class="fas fa-fire-alt"></i>
            <h3>热量分析</h3>
            <p>准确计算卡路里，掌控每日摄入</p>
          </div>
          <div class="feature-card">
            <i class="fas fa-chart-bar"></i>
            <h3>营养报告</h3>
            <p>蛋白质、脂肪、碳水全面分析</p>
          </div>
          <div class="feature-card">
            <i class="fas fa-history"></i>
            <h3>饮食记录</h3>
            <p>智能记录饮食习惯，科学管理健康</p>
          </div>
        </div>
      </section>

      <!-- 下载区域 -->
      <section id="download-section" class="download">
        <h2>立即体验</h2>
        <p>下载恰恰好，开启智能饮食新生活</p>
        <div class="download-buttons">
          <a href="https://apps.apple.com/cn/app/%E6%81%B0%E6%81%B0%E5%A5%BD/id6736365854" 
             class="download-btn ios" 
             target="_blank" 
             rel="noopener noreferrer">
            <i class="fab fa-apple"></i>
            <span>
              <small>下载自</small>
              App Store
            </span>
          </a>
          <a href="https://www.pgyer.com/qiaqiahao" class="download-btn android">
            <i class="fab fa-android"></i>
            <span>
              <small>下载自</small>
              Android
            </span>
          </a>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer>
      <div class="footer-content">
        <p>&copy; 2024 恰恰好 All rights reserved</p>
        <p class="contact"><a href="mailto:dongsen001@gmail.com">dongsen001@gmail.com</a></p>
        <p class="icp">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
            <i class="fas fa-shield-alt"></i>
            <span>京ICP备2024091249号</span>
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    scrollToSection(sectionId) {
      // 阻止路由导航
      if (window.location.pathname !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            const element = document.getElementById(sectionId)
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' })
            }
          })
        })
      } else {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }
}
</script>

<style scoped>
.home {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}

:root {
  margin: 0;
  padding: 0;
}

main {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 100;
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.logo-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: bold;
  color: #D3C0FA;
}

.nav-links a {
  margin-left: 2rem;
  text-decoration: none;
  color: #666;
  transition: color 0.3s;
  cursor: pointer;
}

.nav-links a:hover {
  color: #D3C0FA;
}

.hero {
  width: 100%;
  margin: 0;
  padding-top: 80px;
  background: linear-gradient(135deg, #D3C0FA 0%, #5425BA 100%);
  color: white;
  text-align: center;
  padding-bottom: 4rem;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero-subtitle {
  font-size: 1.5rem;
  opacity: 0.9;
  margin-bottom: 2rem;
}

.features {
  padding: 8rem 2rem;
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.features-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 10% 20%, rgba(211, 192, 250, 0.1) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(211, 192, 250, 0.1) 0%, transparent 20%);
  pointer-events: none;
  z-index: 0;
}

.features-header {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 6rem;
}

.features-header h2 {
  font-size: 3rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.features-subtitle {
  font-size: 1.4rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.feature-grid {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4rem;
  max-width: 1400px;
  margin: 0 auto;
}

.feature-card {
  text-align: center;
  padding: 4rem 3rem;
  background: white;
  border-radius: 24px;
  box-shadow: 0 12px 24px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 16px 32px rgba(0,0,0,0.15);
}

.feature-card i {
  font-size: 4rem;
  color: #D3C0FA;
  margin-bottom: 2rem;
}

.feature-card h3 {
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  color: #2c3e50;
}

.feature-card p {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.8;
}

.download {
  background: #f8f9fa;
  padding: 4rem 2rem;
  text-align: center;
}

.download h2 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.download p {
  margin-bottom: 2rem;
  color: #666;
}

.download-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.download-btn {
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  color: white;
  transition: opacity 0.3s;
}

.download-btn i {
  font-size: 2rem;
  margin-right: 0.8rem;
}

.download-btn span {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.download-btn small {
  font-size: 0.8rem;
}

.ios {
  background: #000;
}

.android {
  background: #3DDC84;
}

.download-btn:hover {
  opacity: 0.9;
}

footer {
  text-align: right;
  padding: 2rem 4rem 2rem 2rem;
  background: #1F2937;
  color: #F3F4F6;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-items: flex-end;
}

.contact a, .icp a {
  color: #9CA3AF;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact a:hover, .icp a:hover {
  color: #D3C0FA;
}

.icp {
  font-size: 0.9rem;
}

.icp a {
  color: #A9B1BD;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.icp a:hover {
  color: #D3C0FA;
}

.icp i {
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }
  
  .nav-content {
    padding: 1rem;
  }
  
  .feature-grid {
    grid-template-columns: 1fr;
  }
  
  .download-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .download-btn {
    width: 80%;
  }
  
  footer {
    padding: 2rem;
  }
}

@media (max-width: 1024px) {
  .feature-grid {
    grid-template-columns: 1fr;
    max-width: 600px;
  }
}

@media (max-width: 1200px) {
  .feature-grid {
    grid-template-columns: 1fr;
    max-width: 700px;
    gap: 3rem;
  }
  
  .features {
    padding: 6rem 2rem;
  }
  
  .features-header h2 {
    font-size: 2.5rem;
  }
  
  .features-subtitle {
    font-size: 1.2rem;
  }
}

html {
  scroll-behavior: smooth;
}

#features-section, #download-section {
  scroll-margin-top: 80px;
}
</style> 